class MCartPromoBar extends HTMLElement {
  constructor() {
    super();
    this.progressBar = this.querySelector('.m-cart-promo-bar__bar-fill');
    this.messageElement = this.querySelector('.m-cart-promo-bar__message');
    this.lockIcon = this.querySelector('.m-cart-promo-bar__lock-icon');
    this.thresholdType = this.dataset.thresholdType || 'value';
    this.cartTotal = parseFloat(this.dataset.cartTotal) || 0;
    this.cartItemCount = parseInt(this.dataset.cartItemCount, 10) || 0;
    this.threshold = parseFloat(this.dataset.threshold) || 229;
    this.barStyle = this.dataset.style || 'default';
    this.msgSuccess = this.dataset.msgSuccess || '';
    this.msgRemaining = this.dataset.msgRemaining || '';
    this.isUpdating = false;
    this.init();
  }

  init() {
    this.updateProgress();
    this.listenForCartUpdates();
    this.observeCartChanges();
  }

  updateProgress() {
    const current = this.cartTotal;
    const progressPercentage = Math.min((current / this.threshold) * 100, 100);
    const isGoalReached = current >= this.threshold;

    if (this.progressBar) {
      this.progressBar.style.setProperty('--progress-percentage', `${progressPercentage}%`);
    }

    const shouldShow = this.cartItemCount > 0;
    const isCurrentlyVisible = this.style.display !== 'none';
    if (shouldShow !== isCurrentlyVisible) {
      this.style.display = shouldShow ? 'block' : 'none';
    }
  }

  listenForCartUpdates() {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, (cartData) => {
        if (cartData && cartData.total_price !== undefined) {
          this.cartTotal = cartData.total_price / 100;
          if (typeof cartData.item_count === 'number') this.cartItemCount = cartData.item_count;
          this.updateProgress();
        }
      });
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, () => {
        setTimeout(() => this.updateCartTotal(), 300);
      });
    }

    document.addEventListener('cart:updated', (event) => {
      if (event.detail && event.detail.cart) {
        this.cartTotal = event.detail.cart.total_price / 100;
        if (typeof event.detail.cart.item_count === 'number') this.cartItemCount = event.detail.cart.item_count;
        this.updateProgress();
      }
    });

    document.addEventListener('DOMContentLoaded', () => {
      const cartDrawer = document.querySelector('m-cart-drawer');
      if (cartDrawer) {
        const observer = new MutationObserver(() => setTimeout(() => this.updateCartTotal(), 100));
        observer.observe(cartDrawer, { childList: true, subtree: true });

        const cartDrawerObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if (cartDrawer.classList.contains('m-cart-drawer--active')) {
                setTimeout(() => this.updateCartTotal(), 300);
              }
            }
          });
        });
        cartDrawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
      }
    });

    document.addEventListener('change', (event) => {
      if (event.target.matches('input[data-index]')) {
        setTimeout(() => this.updateCartTotal(), 500);
      }
    });
  }

  observeCartChanges() {
    const cartTotalElement = document.querySelector('[data-cart-subtotal-price]');
    if (cartTotalElement) {
      const observer = new MutationObserver(() => {
        const totalText = cartTotalElement.textContent || '';
        const totalMatch = totalText.match(/[\d,]+\.?\d*/);
        if (totalMatch) {
          const newTotal = parseFloat(totalMatch[0].replace(/,/g, ''));
          if (!isNaN(newTotal) && newTotal !== this.cartTotal) {
            this.cartTotal = newTotal;
            this.updateProgress();
          }
        }
      });
      observer.observe(cartTotalElement, { childList: true, characterData: true, subtree: true });
    }

    const cartCountElements = document.querySelectorAll('.m-cart-count-bubble');
    cartCountElements.forEach(element => {
      const observer = new MutationObserver(() => {
        const itemCount = parseInt(element.textContent) || 0;
        if (itemCount === 0) {
          this.cartTotal = 0;
          this.cartItemCount = 0;
          this.updateProgress();
        } else if (itemCount !== this.cartItemCount) {
          this.cartItemCount = itemCount;
          this.updateProgress();
        }
      });
      observer.observe(element, { childList: true, characterData: true });
    });
  }

  updateCartTotal() {
    if (this.isUpdating) return;
    this.isUpdating = true;
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const newTotal = cart.total_price / 100;
        const newCount = typeof cart.item_count === 'number' ? cart.item_count : 0;
        if (newTotal !== this.cartTotal || newCount !== this.cartItemCount) {
          this.cartTotal = newTotal;
          this.cartItemCount = newCount;
          this.updateProgress();
        }
      })
      .catch(error => console.error('Erro ao atualizar total do carrinho:', error))
      .finally(() => { this.isUpdating = false; });
  }
}

// ===== TIMER ATÉ MEIA NOITE =====
(function() {
  function getSecondsUntilMidnight() {
    var now = new Date();
    var midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    return Math.floor((midnight - now) / 1000);
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function updateTimer() {
    var el = document.getElementById('promoTimerCountdown');
    if (!el) return;
    var total = getSecondsUntilMidnight();
    if (total <= 0) total = 0;
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  updateTimer();
  setInterval(updateTimer, 1000);
})();

// ===== HINTS DINÂMICAS =====
(function() {
  function getConfig() {
    var bar = document.querySelector('[data-cart-promo-bar]');
    if (!bar) return null;
    return {
      freteThreshold: parseFloat(bar.dataset.freteThreshold) || 180,
      brindeThreshold: parseFloat(bar.dataset.brindeThreshold) || 229,
      freteEnabled: bar.dataset.freteEnabled !== 'false'
    };
  }

  function formatMoney(value) {
    return 'R$ ' + value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.');
  }

  function updatePromoBar(cart) {
    var config = getConfig();
    if (!config) return;

    var total = cart.total_price / 100;
    var itemCount = cart.item_count;

    var freteReached = total >= config.freteThreshold;
    var brindeReached = total >= config.brindeThreshold;
    var freteRemaining = Math.max(config.freteThreshold - total, 0);
    var brindeRemaining = Math.max(config.brindeThreshold - total, 0);
    var brindeProgress = Math.min((total / config.brindeThreshold) * 100, 100);

    // Visibilidade da promo bar
    var promoBar = document.querySelector('[data-cart-promo-bar]');
    if (promoBar) {
      promoBar.style.display = itemCount > 0 ? 'block' : 'none';
    }

    // Barra de progresso (brinde)
    var barFill = document.querySelector('.m-cart-promo-bar__bar-fill');
    if (barFill) {
      barFill.style.width = brindeProgress + '%';
    }

    // Hint frete
    if (config.freteEnabled) {
      var hintFrete = document.querySelector('[data-hint-frete]');
      if (hintFrete) {
        if (freteReached) {
          hintFrete.classList.add('is-reached');
          hintFrete.innerHTML = '<span>✅ Você ativou o <strong>Frete Grátis</strong>!</span>';
        } else {
          hintFrete.classList.remove('is-reached');
          hintFrete.innerHTML = '<span>🚚 Adicione mais <strong>' + formatMoney(freteRemaining) + '</strong> para ativar o <strong>Frete Grátis</strong></span>';
        }
      }
    }

    // Hint brinde
    var hintBrinde = document.querySelector('[data-hint-brinde]');
    if (hintBrinde) {
      if (brindeReached) {
        hintBrinde.classList.add('is-reached');
        hintBrinde.innerHTML = '<span>🎉 Você ganhou <strong>1 Brinde Grátis</strong>!</span>';
      } else {
        hintBrinde.classList.remove('is-reached');
        hintBrinde.innerHTML = '<span>🎁 Adicione <strong>' + formatMoney(brindeRemaining) + '</strong> e ganhe <strong>1 Brinde</strong>!</span>';
      }
    }
  }

  function syncPromoBar() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updatePromoBar(cart); })
      .catch(console.error);
  }

  document.addEventListener('DOMContentLoaded', syncPromoBar);
  document.addEventListener('cart:updated', syncPromoBar);
  document.addEventListener('minimog:cart:updated', syncPromoBar);
  setTimeout(syncPromoBar, 300);
  setTimeout(syncPromoBar, 800);
})();

customElements.define('m-cart-promo-bar', MCartPromoBar);
